export default __webpack_public_path__ + "static/media/cryptocrispy (1).da8ec30e.png";